<template>
  <div class="select-dialog" v-if="dialogVisible">
    <div class="modal-content">
      <div class="content-title">
        {{modalTitle}}
        <i class="el-icon-close custom-style" @click="cancel"></i>
      </div>
      <div class="content-params">
        <!-- 组织名称 -->
        <div class="params">
          <label class="custom_label">组织名称：</label>
          <span style="min-width:210px"><el-input placeholder="请输入组织名称" v-model="filterText"></el-input></span>
        </div>
        <!-- 员工编号 -->
        <div class="params">
          <label class="custom_label">组织编码：</label>
          <span style="min-width:210px"><el-input placeholder="请输入组织编码" v-model="filterText1"></el-input></span>
        </div>
        <!--<span class="orgBtn btn-font" @click="search()"><i class="iconfont icon-chaxun"></i><label>搜索</label></span>-->
      </div>
      <div class="tree-wrapper">
        <el-tree
        :data="data"
        show-checkbox
        default-expand-all
        :default-checked-keys="defaultCheckedKeys"
        node-key="id"
        ref="tree"
        highlight-current
        :props="defaultProps"
        :filter-node-method="filterNode"
        >
      </el-tree>
      </div>
      <div class="confirm-btn">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm">确认</el-button>
      </div>
    </div>
    <div class="modal-mask" @click="cancel"></div>
  </div>
</template>
<script>
export default {
  name: "checkbox-dialog",
  props: {
    modalTitle: String,
    defaultProps: Object,
    data: Array,
    defaultCheckedKeys: Array,
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filterText: "",
      filterText1: "",
      realFilterText: "",
      selectItem: {}
    };
  },
  created() {
    console.log(this.data)
  },
  watch: {
    filterText(val) {
      this.realFilterText = val + '|' + this.filterText1
      this.$refs.tree.filter(this.realFilterText);
    },
    filterText1(val) {
      this.realFilterText = this.filterText + '|' + val
      this.$refs.tree.filter(this.realFilterText);
    }
  },
  methods: {
    search(val) {
      this.$refs.tree.filter(val);
    },
    cancel() {
      this.reset()
      this.$emit("cancel");
    },
    reset() {
      this.filterText1 = ''
      this.filterText = ''
    },
    confirm() {
      const keys = this.$refs.tree.getCheckedNodes()
      if (keys && keys.length < 1) {
        this.$message.error('请选择组织')
      } else {
        this.$emit("confirm-select-item", keys);
        this.reset()
      }
    },
    filterNode(value, data, node) {
      console.log(value);
      //   console.log(2222);
      //   if (!value) return true;
      //   return data.label.indexOf(value) !== -1;
      // 如果什么都没填就直接返回
      if (!value) return true;
      const searchKeys = value.split('|')
      const s1 = searchKeys[0]
      const s2 = searchKeys[1]
      var searchName = this.defaultProps.searchName
        ? this.defaultProps.searchName
        : [].concat([this.defaultProps.label]);
      if (searchName) {
        var len = searchName.length;
        if (len > 0) {
          for (let i = 0; i < len; i++) {
            const taget = data[searchName[i]]
            if ((taget.indexOf(s1) !== -1) && (taget.indexOf(s2) !== -1)) {
              return true;
            }
          }
        }
      }
      // 否则要去判断它是不是选中节点的子节点
      return this.checkBelongToChooseNode(value, data, node, searchName);
    },
    // 判断传入的节点是不是选中节点的子节点
    checkBelongToChooseNode(value, data, node, searchName) {
      const level = node.level;
      // 如果传入的节点本身就是一级节点就不用校验了
      if (level === 1) {
        return false;
      }
      // 先取当前节点的父节点
      let parentData = node.parent;
      // 遍历当前节点的父节点
      let index = 0;
      while (index < level - 1) {
        if (searchName && searchName.length > 0) {
          var len = searchName.length;
          for (let i = 0; i < len; i++) {
            if (parentData.data[searchName[i]].indexOf(value) !== -1) {
              return true;
            }
          }
        }
        // 否则的话再往上一层做匹配
        parentData = parentData.parent;
        index++;
      }
      // 没匹配到返回false
      return false;
    },
    nodeClick(data, node) {
      if (node.level === 1) {
        const children = node.childNodes
        // 按目前数据情况，只做了点击一级展开所有二级
        children.length > 0 && children.map(child => {
          child.expanded = true;
        })
      }
      this.selectItem = node;
    }
  }
};
</script>
<style type="text/scss" lang="scss" scoped>
.select-dialog {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  .modal-content {
    position: absolute;
    left: 0;
    top: 0;
    width: 80%;
    z-index: 999;
    transform: translate(-50%, 18%);
    margin-left: 50%;
    padding: 15px 15px 8px 15px;
    background-color: #fff;
    border: 1px solid #e3e3e3;
    border-radius: 10px;
    .content-title {
      padding:0 0 14px;
      .custom-style {
        position: absolute;
        right: 10px;
        top: 10px;
        color: #888;
      }
    }
    .tree-wrapper {
      height: 420px;
      border: 1px solid #f3f3f3;
      margin: 10px 0;
      overflow-x: hidden;
      overflow-y: scroll;
    }
    .confirm-btn {
      padding: 6px 0;
      text-align: center;
    }
  }
  .modal-mask {
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.5;
  }
  .content-params {
    padding:5px 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    overflow: hidden;
    .params {
      max-width:200px;
      margin: 5px 0;
      font-size: 0;
    }
    .custom_label {
      min-width: 80px;
      display:inline-block;
      font-size: 14px;
      font-weight:700;
      text-align: right;
      color:#606266;
      i {
        color: red;
        font-style: normal;
        vertical-align: middle;
      }
    }
  }

}
</style>
<style type="text/scss"  scoped>
.params .el-input{
    width:210px!important;
  }
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/components/checkbox-dialog.vue